// extracted by mini-css-extract-plugin
export default {"maxWidth860":"BookingLayout_maxWidth860__Hq-T0","body":"BookingLayout_body__9wLro","footer":"BookingLayout_footer__H+m+l"};